class BundlePicker {
  constructor() {
    this.modal = document.getElementById("bundleModal");
    this.bundleGrid = document.querySelector("[data-bundle-grid]");
    this.bundleWrapper = document.querySelector("[data-bundle-wrapper]");
    this.bundleForm = document.querySelector("[data-bundle-form]");
    this.currentSlot = null;
    this.selectedVariants = [];
    
    this.bundleConfig = window.bundleConfig;
    this.priceTarget = this.bundleConfig.priceTarget;
    this.bundleQty = this.bundleConfig.bundleQty;
    this.currencySymbol = this.bundleConfig.currencySymbol;


    this.modalContentLoaded = false;
    this.currentProduct = null;
    this.currentVariant = null;
    this.bundleCollection = [];

    this.moveModalToBody();
    this.initializeBundle();
    this.setupEventListeners();
  }

  async initializeBundle() {
    try {
      await Promise.all([
        this.fetchCurrentProduct(),
        this.fetchBundleCollection(),
      ]);
      this.renderBundleSlots();
    } catch (error) {
      console.error("Failed to initialize bundle:", error);
      this.showBundleError();
    }
  }

  async fetchCurrentProduct() {
    const response = await fetch(
      `${window.Shopify.routes.root}products/${this.bundleConfig.currentProductHandle}.js`
    );
    if (!response.ok) throw new Error("Failed to fetch current product");

    this.currentProduct = await response.json();
    this.currentVariant = this.getCurrentVariant();

    this.currentVariant.price = this.formatPrice(this.currentVariant.price);
    this.currentProduct.price = this.formatPrice(this.currentProduct.price);

    return this.currentProduct;
  }

  async fetchBundleCollection() {
    const handle = this.bundleConfig.promoCollectionHandle;

    try {
      const response = await fetch(
        `${window.Shopify.routes.root}collections/${handle}/products.json?limit=250`
      );

      if (response.ok) {
        const data = await response.json();
        this.bundleCollection = data.products;
        return this.bundleCollection;
      }

      throw new Error(`Collection endpoint failed: ${response.status}`);
    } catch (error) {
      throw new Error(`Failed to fetch bundle collection: ${error.message}`);
    }
  }

  formatPrice(price) {
    return price / 100;
  }

  priceWithCurrency(price) {
    return `${this.currencySymbol}${price}`;
  }

  getCurrentVariant() {
    const urlParams = new URLSearchParams(window.location.search);
    const variantId = urlParams.get("variant");

    if (variantId) {
      const variant = this.currentProduct.variants.find(
        (v) => v.id == variantId
      );
      if (variant) return variant;
    }
    return (
      this.currentProduct.variants.find((v) => v.available) ||
      this.currentProduct.variants[0]
    );
  }

  getProductImage(product, variant = null) {
    if (variant && variant.featured_image) {
      const variantImage = variant.featured_image.src || variant.featured_image;
      if (typeof variantImage === "string") return variantImage;
    }

    if (product.featured_image) {
      if (typeof product.featured_image === "string")
        return product.featured_image;
    }

    if (product.images && product.images.length > 0) {
      const firstImage = product.images[0];
      if (typeof firstImage === "string") return firstImage;
      if (firstImage && firstImage.src && typeof firstImage.src === "string")
        return firstImage.src;
    }

    return "/assets/placeholder.png";
  }

  setupEventListeners() {
    const closeModalButtons = document.querySelectorAll("[data-close-modal]");

    this.bundleGrid.addEventListener("click", (event) => {
      const button = event.target.closest("[data-open-modal]");
      if (button) {
        const slotIndex = button.dataset.openModal;
        this.openModal(slotIndex);
      }
    });

    document.addEventListener("click", (event) => {
      if (event.target.id === "bundleAddToCartBtn") {
        event.preventDefault();
        this.addItemsToCart();
      }
    });

    closeModalButtons.forEach((button) => {
      button.addEventListener("click", (event) => {
        this.closeModal();
      });
    });

    this.modal.addEventListener("click", (event) => {
      const modalContent = this.modal.querySelector(".bundle-modal__content");
      if (!modalContent.contains(event.target)) {
        this.closeModal();
      }
    });

    document.addEventListener("keydown", (event) => {
      if (event.key === "Escape" && this.modal.style.display === "block") {
        this.closeModal();
      }
    });

    const productForm = document.querySelector('form[is="product-form"]');
    if (productForm) {
      productForm.addEventListener(
        "variant:change",
        this.onVariantChange.bind(this)
      );
    }

    this.setupProductSelection();
  }

  onVariantChange(event) {
    this.currentVariant = event.detail.variant;
    this.currentVariant.price = this.formatPrice(this.currentVariant.price);

    this.renderBundleSlots(true);
  }


  renderBundleSlots(updated = false) {
    if (updated === true) {
      this.bundleGrid.innerHTML = "";
      this.bundleForm.innerHTML = "";
    }

    if (!this.currentProduct || !this.currentVariant) {
      return;
    }

    let bundleSlots = [];

    for (let slotIndex = 0; slotIndex < this.bundleQty; slotIndex++) {
      if (slotIndex === 0) {
        this.selectedVariants[0] = {
          variantId: this.currentVariant.id,
          variantTitle: this.currentVariant.title,
          title: this.currentProduct.title,
          image: this.getProductImage(this.currentProduct, this.currentVariant),
          price: this.currentVariant.price,
        };

        bundleSlots[slotIndex] = this.createProductCard(
          this.selectedVariants[0],
          0,
          true
        );
      } else if (this.selectedVariants[slotIndex] && slotIndex > 0) {
        bundleSlots[slotIndex] = this.createProductCard(
          this.selectedVariants[slotIndex],
          slotIndex,
          false
        );
      } else {
        bundleSlots[slotIndex] = this.createEmptySlot(slotIndex);
      }
    }

    const priceForm = this.createPriceForm();
    const buyButton = this.createBuyButton();

    bundleSlots.forEach((slot) => {
      this.bundleGrid.insertAdjacentHTML("beforeend", slot);
    });

    this.bundleForm.insertAdjacentHTML("beforeend", priceForm);
    this.bundleForm.insertAdjacentHTML("beforeend", buyButton);

    this.updatePrice();
  }

  createProductCard(variant, slotIndex, isPreFilled = false) {
    const changeButton = isPreFilled
      ? ""
      : `<button type="button" class="button button--small bundle-edit-btn" data-open-modal="${slotIndex}">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" width="20" height="20">
            <path fill-rule="evenodd" d="M15.655 4.344a2.695 2.695 0 0 0-3.81 0l-.599.599-.009-.009-1.06 1.06.008.01-5.88 5.88a2.75 2.75 0 0 0-.805 1.944v1.922a.75.75 0 0 0 .75.75h1.922a2.75 2.75 0 0 0 1.944-.806l7.54-7.539a2.695 2.695 0 0 0 0-3.81Zm-4.409 2.72-5.88 5.88a1.25 1.25 0 0 0-.366.884v1.172h1.172c.331 0 .65-.132.883-.366l5.88-5.88-1.689-1.69Zm2.75.629.599-.599a1.195 1.195 0 1 0-1.69-1.689l-.598.599 1.69 1.689Z"/>
          </svg>
        </button>`;

    let imageUrl = "";
    if (variant.image) {
      imageUrl = variant.image.startsWith("//")
        ? `https:${variant.image}`
        : variant.image;
    } else {
      imageUrl = this.getProductImage(this.currentProduct, variant);
    }

    const variantTitle =
      variant.variantTitle === "Default Title" ? "" : variant.variantTitle;

    const productTitle = variant.title
      .replace(/\s*(Shortfill|Nic Salt)$/, "")
      .trim();

    return `
        <div class="bundle-item bundle-item--filled" data-bundle-position="${slotIndex}">
            <div class="bundle-product-card">
              <div class="bundle-product-card__media">
                <img src="${imageUrl}" alt="${variant.title || this.currentProduct.title}" width="150" 
                     onerror="this.src='/assets/placeholder.png'">
                  <div class="bundle-product-card__edit">
                  ${changeButton}
                  </div>
              </div>
                <div class="bundle-product-card__details">
                  <h4>${productTitle || this.currentProduct.title}</h4>
                  ${variantTitle ? `<h5>${variantTitle}</h5>` : ""}
                  <p>${this.priceWithCurrency(variant.price)}</p>
                </div>
            </div>
        </div>
        `;
  }

  createEmptySlot(slotIndex) {
    return `
        <div class="bundle-item bundle-item--empty" data-bundle-position="${slotIndex}">
            <button type="button" class="bundle-add-product-btn" data-open-modal="${slotIndex}">
                <span class="bundle-add-product-icon">+</span>
                <span class="bundle-add-product-text">Add Product</span>
            </button>
        </div>
        `;
  }

  createPriceForm() {
    return `
        <div class="bundle-price" id="bundlePriceContainer">
            <span>Total:</span>
            <span id="bundleCurrentPrice"></span>
            <span class="bundle-price__saving" id="bundleCurrentSaving"></span>
        </div>
        `;
  }

  createBuyButton() {
    return `
        <button type="submit" class="button button--secondary bundle-add-to-cart-btn" id="bundleAddToCartBtn" is="hover-button">Add to Cart</button>
        `;
  }

  moveModalToBody() {
    if (this.modal && this.modal.parentNode !== document.body) {
      document.body.appendChild(this.modal);
    }
  }

  openModal(slotIndex) {
    this.currentSlot = slotIndex;

    if (!this.modalContentLoaded) {
      this.renderModalProducts();
      this.modalContentLoaded = true;
    }

    this.modal.style.display = "block";
    this.lockBodyScroll();
  }

  renderModalProducts() {
    const productGrid = document.querySelector("[data-product-grid]");

    if (!productGrid) {
      return;
    }

    const productsHtml = this.bundleCollection
      .map((product) => {
        const hasMultipleVariants =
          product.variants.length > 1 ||
          (product.variants.length === 1 &&
            product.variants[0].title !== "Default Title");

        let variantButtons = "";

        if (hasMultipleVariants) {
          variantButtons = product.variants
            .map((variant) => {
              if (variant.available === true) {
                return `
                        <button type="button" class="bundle-select-variant-btn"
                        data-variant-id="${variant.id}"
                        data-product-title="${product.title}"
                        data-variant-title="${variant.title}"
                        data-product-image="${this.getProductImage(product, variant)}"
                        data-variant-price="${variant.price}">
${variant.title}
                        </button>
                        `;
              } else {
                return `
                        <button type="button" 
                        class="bundle-select-variant-btn" 
                        disabled 
                        title="Out of stock">
                        ${variant.title}
                        </button>
                        `;
              }
            })
            .join("");
        } else {
          const variant = product.variants[0];

          if (variant.available === true) {
            variantButtons = `
              <button type="button" class="bundle-select-variant-btn bundle-select-variant-btn--single"
              data-variant-id="${variant.id}"
              data-product-title="${product.title}"
              data-variant-title="${variant.title}"
              data-product-image="${this.getProductImage(product, variant)}"
              data-variant-price="${variant.price}">
              Add to Cart
              </button>
            `;
          } else {
            variantButtons = `
              <button type="button" 
              class="bundle-select-variant-btn bundle-select-variant-btn--single" 
              disabled 
              title="Out of stock">
              Out of Stock
              </button>
            `;
          }
        }

        const productImage = this.getProductImage(product);
        const imageUrl =
          typeof productImage === "string" && productImage.startsWith("//")
            ? `https:${productImage}`
            : productImage;

        return `
              <div class="bundle-modal-card">
              <div class="bundle-modal-card__media media">
              <img src="${imageUrl}" 
                   alt="${product.title}" 
                   width="120" 
                   onerror="this.src='/assets/placeholder.png'
                   loading="lazy"
                   is="lazy-image"
                   ">
              </div>
              <div class="bundle-modal-card__details">
              <h4>${product.title}</h4>
              <div class="bundle-modal-card__buttons">
              ${variantButtons}
              </div>
              </div>
              </div>
              `;
      })
      .join("");

    productGrid.innerHTML = productsHtml;
  }

  closeModal() {
    this.modal.style.display = "none";
    this.currentSlot = null;
    this.unlockBodyScroll();
  }

  setupProductSelection() {
    this.modal.addEventListener("click", (event) => {
      if (
        event.target.classList.contains("bundle-select-variant-btn") &&
        !event.target.disabled
      ) {
        this.selectProduct(event.target);
      }
    });
  }

  selectProduct(button) {
    const variantId = button.dataset.variantId;
    const productTitle = button.dataset.productTitle;
    const productImage = button.dataset.productImage;
    const variantTitle = button.dataset.variantTitle;
    const variantPrice = button.dataset.variantPrice;

    this.selectedVariants[this.currentSlot] = {
      variantId: variantId,
      variantTitle: variantTitle,
      title: productTitle,
      image: productImage,
      price: variantPrice,
    };

    this.updateSlot(this.currentSlot);
    this.closeModal();
  }

  updateSlot(slotIndex) {
    const slot = document.querySelector(
      `[data-bundle-position="${slotIndex}"]`
    );
    const selectedProduct = this.selectedVariants[slotIndex];

    if (slot && selectedProduct) {
      // Reuse createProductCard method to avoid duplication
      const cardHtml = this.createProductCard(
        selectedProduct,
        slotIndex,
        false
      );
      const tempDiv = document.createElement("div");
      tempDiv.innerHTML = cardHtml;
      const newSlot = tempDiv.firstElementChild;

      slot.replaceWith(newSlot);
    }

    this.updatePrice();
  }

  updatePrice() {
    const currentPriceElement = document.getElementById("bundleCurrentPrice");
    const savingElement = document.getElementById("bundleCurrentSaving");
    const buyButton = document.getElementById("bundleAddToCartBtn");
    const selectedCount = this.selectedVariants.filter(
      (variant) => variant
    ).length;
    let totalPrice = 0;

    this.selectedVariants.forEach((variant) => {
      if (variant) {
        totalPrice += Number(variant.price);
      }
    });

    const bundleIsComplete = selectedCount === this.bundleQty;

    if (buyButton) {
      if (bundleIsComplete) {
        buyButton.disabled = false;
        buyButton.textContent = "Add Bundle to Cart";
        buyButton.classList.remove("button--disabled");
      } else {
        buyButton.disabled = true;
        buyButton.textContent = `Add ${this.bundleQty - selectedCount} More Items`;
        buyButton.classList.add("button--disabled");
      }
    }

    if (bundleIsComplete && totalPrice > this.priceTarget) {
      currentPriceElement.innerText = this.priceWithCurrency(totalPrice);
      currentPriceElement.classList.add("price--strikethrough");
      const saving = (totalPrice - this.priceTarget).toFixed(2);
      savingElement.innerText = `Now ${this.priceWithCurrency(this.priceTarget)} (Saving ${this.priceWithCurrency(saving)})`;
    } else if (bundleIsComplete) {
      currentPriceElement.innerText = this.priceWithCurrency(totalPrice);
      currentPriceElement.classList.remove("price--strikethrough");
      savingElement.innerText = "";
    } else {
      currentPriceElement.innerText = this.priceWithCurrency(totalPrice);
      currentPriceElement.classList.remove("price--strikethrough");
      const remaining = this.bundleQty - selectedCount;
      savingElement.innerText = `Add ${remaining} more item${remaining === 1 ? "" : "s"} for ${this.bundleQty} for ${this.priceWithCurrency(this.priceTarget)}`;
    }
  }

  addItemsToCart() {
    const selectedCount = this.selectedVariants.filter(
      (variant) => variant
    ).length;
    if (selectedCount !== this.bundleQty) {
      return;
    }

    const data = {
      items: this.selectedVariants
        .filter((variant) => variant)
        .map((variant) => ({
          id: parseInt(variant.variantId),
          quantity: 1,
        })),
    };

    if (
      document.body.classList.contains("template-cart") ||
      theme.settings.cartType === "page"
    ) {
      theme.utils.postLink2(theme.routes.cart_add_url, {
        parameters: {
          ...data,
        },
      });
      return;
    }

    this.disableButton();
    this.handleErrorMessage();

    let sectionsToBundle = [];
    document.documentElement.dispatchEvent(
      new CustomEvent("cart:bundled-sections", {
        bubbles: true,
        detail: { sections: sectionsToBundle },
      })
    );

    const body = JSON.stringify({
      ...data,
      sections: sectionsToBundle,
      sections_url: window.location.pathname,
    });

    fetch(`${theme.routes.cart_add_url}`, {
      ...theme.utils.fetchConfig("javascript"),
      body,
    })
      .then((response) => response.json())
      .then(async (parsedState) => {
        if (parsedState.status) {
          this.handleErrorMessage(parsedState.description);
          document.dispatchEvent(
            new CustomEvent("ajaxProduct:error", {
              detail: {
                errorMessage: parsedState.description,
              },
            })
          );
          this.error = true;
          return;
        }

        const cartJson = await (
          await fetch(theme.routes.cart_url, {
            ...theme.utils.fetchConfig("json", "GET"),
          })
        ).json();
        cartJson["sections"] = parsedState["sections"];

        theme.pubsub.publish(theme.pubsub.PUB_SUB_EVENTS.cartUpdate, {
          source: "bundle-picker",
          cart: cartJson,
        });

        document.dispatchEvent(
          new CustomEvent("ajaxProduct:added", {
            detail: {
              product: parsedState,
            },
          })
        );

        this.closeModal();

        const cartDrawer = document.querySelector("cart-drawer");
        cartDrawer?.show();
      })
      .catch((error) => {
        this.handleErrorMessage(
          "Failed to add bundle to cart. Please try again."
        );
      })
      .finally(() => {
        this.enableButton();
        if (this.error) {
          const addToCartBtn = document.getElementById("bundleAddToCartBtn");
          if (addToCartBtn) {
            addToCartBtn.setAttribute("aria-disabled", "true");
          }
        }

        document.dispatchEvent(
          new CustomEvent("cart:refresh", {
            bubbles: true,
            detail: { open: true },
          })
        );
      });
  }

  disableButton() {
    const addToCartBtn = document.getElementById("bundleAddToCartBtn");
    if (addToCartBtn) {
      addToCartBtn.setAttribute("aria-disabled", "true");
      addToCartBtn.setAttribute("aria-busy", "true");
      addToCartBtn.innerText = "Adding to cart...";
    }
  }

  enableButton() {
    const addToCartBtn = document.getElementById("bundleAddToCartBtn");
    if (addToCartBtn && !this.error) {
      addToCartBtn.removeAttribute("aria-disabled");
      addToCartBtn.removeAttribute("aria-busy");
      this.resetBundle();
    }
  }

  resetBundle() {
    this.selectedVariants = [];

    this.bundleGrid.innerHTML = "";
    this.bundleForm.innerHTML = "";

    this.renderBundleSlots();

    if (this.modal.style.display === "block") {
      this.closeModal();
    }

    this.handleErrorMessage();
    this.error = false;
  }

  handleErrorMessage(errorMessage = false) {
    this.errorMessage =
      this.errorMessage ||
      document.querySelector(".bundle-picker__error-message");
    if (!this.errorMessage) return;

    this.errorMessage.toggleAttribute("hidden", !errorMessage);
    if (errorMessage) {
      this.errorMessage.innerText = errorMessage;
    }
  }

  lockBodyScroll() {
    this.scrollPosition = window.pageYOffset;
    document.body.classList.add("bundle-modal-open");
    document.body.style.top = `-${this.scrollPosition}px`;
  }

  unlockBodyScroll() {
    document.body.classList.remove("bundle-modal-open");
    document.body.style.top = "";
    window.scrollTo(0, this.scrollPosition);
  }

  showBundleError() {
    this.bundleGrid.innerHTML = `
      <div class="bundle-error">
        <p>Failed to load bundle. Please refresh the page.</p>
      </div>
    `;
  }
  
}

document.addEventListener("DOMContentLoaded", () => {
  new BundlePicker();
});
